import React, {useEffect, useRef, useState} from 'react';
import {getContentDetail} from "../apis/contents";
import {useHistory, useParams} from "react-router-dom";
import {ContentDetail, ScoreType, TargetType} from "../types/types";
// @ts-ignore
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import moment from "moment";
import { ContentInfoEventProperties, ContentTabEventProperties } from '../types/amplitudeEventProperties';
import { Bridge } from '../plugins/bridge';
import { BRAZE_EVENT } from '../constants/braze';
import {nToast} from "../plugins/reactToast";
import {scoreUp} from "../apis/score";

export const JournalDetailPage = () => {
    const {id} = useParams<{ id: string }>()
    const numId = parseInt(id)
    const [content, setContent] = useState<ContentDetail>()
    const mounted = useRef(false);
    const contentDiv = useRef<HTMLDivElement>(null);
    const {push} = useHistory()
    useEffect(() => {
        getContentDetail(numId).then(r => setContent(r.data.payload)).catch(e => console.log(e));
    }, [])

    useEffect(() => {
        const content_info = {
            content_tab : '기사',
            content_id : String(content?.contentId),
            content_name : String(content?.title)
        }

        if(content?.contentId != undefined){
            Bridge.sendAmplitude('content_viewed', content_info);
            Bridge.sendBraze(BRAZE_EVENT.CONTENT_VIEWED, content_info);
            scoreUp(content?.contentId, TargetType.CONTENT, ScoreType.VIEW);
        }
        contentDiv && contentDiv.current && (
            contentDiv.current.onclick = function(event) {
                event.preventDefault();

                let target = event.target;
                for(; null !== (target as HTMLInputElement).parentElement && (target as HTMLInputElement).nodeName != 'A'; target=(target as HTMLInputElement).parentElement);
                if( (target as HTMLInputElement).nodeName !== 'A') return;

                if(String(target).indexOf('copytext') > -1) {
                    const arrText = String(target).split("-")
                    const copyCode = arrText[1].replace("/", '').toUpperCase()
                    navigator.clipboard.writeText(
                        copyCode
                    ).then( ()=>
                        nToast('복사 완료')
                    ).catch( err=> {
                        console.log(err);
                        nToast('복사 실패')
                        }
                    )
                    return;
                }

                const link = String(target).replace('www.', '').replace('WWW.', '')
                const domain = process.env.REACT_APP_MODE === 'development' ? 'https://carhartt-wip.entropyparadox.link' : 'https://carhartt-wip.co.kr';

                if(link.indexOf(domain) > -1){
                    const url = link.replace(domain, "");
                    window.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'contentId=' + content?.contentId
                }else if(link.indexOf('https://') > -1){
                    window.open(link)
                }
            }
        )
    }, [content]);

    useEffect(() => {
        document.getElementsByTagName('main')[0].style.backgroundColor = content?.backgroundColor!;
        document.getElementsByTagName('main')[0].style.color = content?.textColor!;
        const spanList = document.getElementsByTagName('span');
        //@ts-ignore
        for (let item of spanList) {
            if (item.id !== 'counter-badge') {
                item.style.color = content?.textColor!;
            }
        }
        return () => {
            document.getElementsByTagName('main')[0].style.backgroundColor = '';
            document.getElementsByTagName('main')[0].style.color = '';
            //@ts-ignore
            for (let item of spanList) {
                item.style.color = '';
            }
        }
    }, [content])

    if (!content) return null
    return (
        <div className="pt-11 -mx-4 overflow-hidden">
            <style dangerouslySetInnerHTML={{__html: `
              .fr-view img.fr-dib{margin:0 auto;}
              h4{font-weight:400;font-size:12px;}
              .fr-view img{object-fit:cover;}
              .contents_list2{
              display:flex;
              flex-wrap: wrap;
              max-width:1300px;
              margin:0 auto;
              font-size:12px;
              column-gap: 10px;
              justify-content: center;
              font-weight:800;
              }
              .contents_list2 h2, .contents_list2 h3, .contents_list2 h4{
              font-size:12px;
              line-height:1.2;
              font-weight:700;
              }
              .contents_list2 h3{
              text-decoration:line-through;
              color:#9298a5;
              }
              .contents_list2 h3, .contents_list2 h4{
              display:inline-block;
              }
              .contents_list2 h4{color:#ec393c; margin-right:5px;}
              .contents_list2>div{
              width:200px;
              margin-bottom:80px;
              }
              .contents_list2>div>p{
              position:relative;
              padding:0 !important;
              }
              .contents_list2 img{
              width:100%;
              height:100%;
              }
              .contents_list2 span{
              position:absolute;
              top:0;
              left:0;
              width:100%;
              height:100%;
              background:#fff;
              opacity:0;
              z-index:1;
              transition:0.2s all;
              text-indent:-9999px;
              }
              .contents_list2 span:hover{
              position:absolute;
              top:0;
              left:0;
              width:100%;
              height:100%;
              background:white;
              opacity:0.6;
              transition:0.2s all;
              cursor:pointer;
              }
              @media (max-width: 640px) {
                .contents_list2{
                display:grid;
                padding:50px 10px; 
                grid-template-columns: repeat(2, minmax(0, 1fr));
                
                }
                .contents_list2>div{
                width:100%;
                padding-bottom:10px;
                }
                .contents_list2 h4{color:#ec393c; margin-right:5px;}
                .contents_list2>div{
                width:200px;
                margin-bottom:20px;
              }
              }
              .contents_list3{
              display: flex;
              flex-wrap: wrap;
              max-width: 1600px;
              margin: 72px auto 20px auto;
              font-size: 12px;
              column-gap: 10px;
              justify-content: center;
              overflow: hidden;
              }
              .contents_list3 div{
              overflow:hidden;
              width:250px;
              position:relative;
              }
              .contents_list3 a{
              position:absolute;
              top:18px;
              left:0;
              width:100%;
              font-weight:600;
              font-size:13px;
              text-align:center;
              opacity:0;
              color:black;
              height:100%;
              background:rgba(255,255,255,0);
              z-index:1;
              transition:0.2s all;
              }
              .contents_list3 div a:hover{
              position:absolute;
              top:18px;
              left:0;
              width:100%;
              height:100%;
              background:rgba(255,255,255,0.7);
              transition:0.2s all;
              opacity:1;
              cursor:pointer;
              }
              .contents_list3 div a span{
              position:absolute;
              width:100%;
              left:0;
              right:0;
              top:45%;
              }

              .contents_list_black{
              display: flex;
              flex-wrap: wrap;
              max-width: 1600px;
              margin: 72px auto 20px auto;
              font-size: 12px;
              column-gap: 10px;
              justify-content: center;
              overflow: hidden;
              }
              .contents_list_black div{
              overflow:hidden;
              width:250px;
              position:relative;
              }
              .contents_list_black a{
              position:absolute;
              top:0;
              left:0;
              width:100%;
              font-weight:600;
              font-size:13px;
              text-align:center;
              opacity:0;
              color:white;
              height:100%;
              background:rgba(0,0,0,0);
              z-index:1;
              transition:0.2s all;
              }
              .contents_list_black div a:hover{
              position:absolute;
              top:0;
              left:0;
              width:100%;
              height:100%;
              background:rgba(0,0,0,0.5);
              transition:0.2s all;
              opacity:1;
              cursor:pointer;
              }
              .contents_list_black div a span{
              position:absolute;
              width:100%;
              left:0;
              right:0;
              top:45%;
              }
              
            
              .contents_list_gray{
              display:grid;
              grid-template-columns: repeat(4, minmax(0, 1fr));
              max-width:1400px;
              margin:0 auto;
              }
              .contents_list_gray div{
              overflow:hidden;
              margin:0 15px;
              }
              .contents_list_gray img{
              
              }
              .contents_list_gray a{
              position:absolute;
              top:0;
              left:0;
              width:100%;
              font-weight:600;
              font-size:13px;
              text-align:center;
              opacity:0;
              color:white;
              height:100%;
              background:rgba(255,255,255,0);
              z-index:1;
              transition:0.2s all;
              }
              .contents_list_gray div{
              position:relative;
              }
              .contents_list_gray div a:hover{
              position:absolute;
              top:0;
              left:0;
              width:100%;
              height:100%;
              background:rgba(132, 132, 132, 0.7);
              transition:0.2s all;
              opacity:1;
              cursor:pointer;
              }
              .contents_list_gray div a span{
              position:absolute;
              width:100%;
              left:0;
              right:0;
              top:50%;
              }
              
              
              .contents_list5{
              display:grid;
              grid-template-columns: repeat(3, minmax(0, 1fr));
              max-width:1400px;
              margin:0 auto;
              }
              .contents_list5 div{
              overflow:hidden;
              margin:0 15px;
              }
              .contents_list5 img{
              
              }
              .contents_list5 a{
              position:absolute;
              top:0;
              left:0;
              width:100%;
              font-weight:600;
              font-size:13px;
              text-align:center;
              opacity:0;
              color:black;
              height:100%;
              background:rgba(255,255,255,0);
              z-index:1;
              transition:0.2s all;
              }
              .contents_list5 div{
              position:relative;
              }
              .contents_list5 div a:hover{
              position:absolute;
              top:0;
              left:0;
              width:100%;
              height:100%;
              background:rgba(255,255,255,0.7);
              transition:0.2s all;
              opacity:1;
              cursor:pointer;
              }
              .contents_list5 div a span{
              position:absolute;
              width:100%;
              left:0;
              right:0;
              top:50%;
              }
              
              @media (max-width: 1300px) {
              .contents_list3{
              display: flex;
              flex-wrap: wrap;
              max-width: 1600px;
              margin: 72px auto 20px auto;
              font-size: 12px;
              column-gap: 10px;
              justify-content: center;
              overflow: hidden;
              }
              .contents_list_black{
              display: flex;
              flex-wrap: wrap;
              max-width: 1600px;
              margin: 72px auto 20px auto;
              font-size: 12px;
              column-gap: 10px;
              justify-content: center;
              overflow: hidden;
              }
              .contents_list_gray{
              display:grid;
              grid-template-columns: repeat(3, minmax(0, 1fr));
              max-width:1400px;
              margin:0 auto;
              }
              
              .contents_list5{
              display:grid;
              grid-template-columns: repeat(3, minmax(0, 1fr));
              max-width:1400px;
              margin:0 auto;
              }
              }
              @media (max-width: 640px) {
              .contents_list3{
              display:grid;
              grid-template-columns: repeat(2, minmax(0, 1fr));
              max-width:1400px;
              margin:0 10px;
              }
              .contents_list3 div{
              overflow:hidden;
              width:100%;
              position:relative;
              }
              .contents_list_black{
              display:grid;
              grid-template-columns: repeat(2, minmax(0, 1fr));
              max-width:1400px;
              margin:0 10px;
              }
              .contents_list_black div{
              overflow:hidden;
              width:100%;
              position:relative;
              }
              .contents_list_gray{
              display:grid;
              grid-template-columns: repeat(2, minmax(0, 1fr));
              max-width:1400px;
              margin:0 auto;
              }
              .contents_list_gray div{
              overflow:hidden;
              margin:0 2px;
              }
              
              .contents_list5{
              display:grid;
              grid-template-columns: repeat(2, minmax(0, 1fr));
              max-width:1400px;
              margin:0 auto;
              }
              .contents_list5 div{
              overflow:hidden;
              margin:0 2px;
              }
              }
              -webkit-tap-highlight-color : transparent;
            `}}/>
            <div className='px-4'>
            <h1 className="font-bold text-24">{content.title}</h1>

            <span className="text-12 pt-8">{moment(content.createdAt).format('YYYY-MM-DD')}</span>
            </div>

            <div id={'journal'} ref={contentDiv} style={{backgroundColor: content.backgroundColor!, color: content.textColor!, paddingTop: 20, wordBreak: "keep-all"}}>
                <FroalaEditorView model={content.contents}/>
            </div>
        </div>
    );
};
